<template>
  <div id="app">
    <router-view v-if="isreload" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isreload: true,
    };
  },
  methods: {
    reload() {
      this.isreload = false;
      this.$nextTick(function() {
        this.isreload = true;
      });
    },
  },
};
</script>

<style>
@import "/assets/ar.css";
.header .language-popover {
  margin-right: 12px;
}
.header .language-popover .el-popover__reference-wrapper .icon:first-child {
  display: inline-block !important;
}
.header .language-popover .el-popover__reference-wrapper .icon:nth-child(2) {
  display: none;
}
.language-popper {
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));
  min-width: auto !important;
}
body {
  top: 0 !important;
}
body > div.skiptranslate {
  position: relative;
  z-index: -1;
}

.skiptranslate > .skiptranslate {
  height: 0 !important;
  width: 0 !important;
  box-shadow: 0;
  display: none !important;
}
#goog-gt-tt.skiptranslate {
  height: 0 !important;
  width: 0 !important;
  box-shadow: 0;
  display: none !important;
}
.VIpgJd-ZVi9od-aZ2wEe-wOHMyf.VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc {
  display: none;
}

.el-select.options .el-input__inner {
  border: 1px solid #e1e3e6;
  border-radius: 12px;
}

.fff {
  min-height: calc(100% - 40px - 60px) !important;
  position: relative;
  padding-bottom: 73px;
}

.Setting_li .el-select .el-input__inner {
  border: none !important;
}

.Setting_li .el-select .el-input.is-focus .el-input__inner {
  border: none !important;
}

.language {
  /* height: 35px !important; */
}

.el-popover {
  border: 0 solid #ebeef5;
  /*background-color: transparent;*/
  box-shadow: none;

}

input {
  font-size: 14px !important;
  color: #000927;
  font-family: Noto Sans;
}

input::placeholder {
  color: #9f9f9f;
}

#login_lo .title {
  font-family: Noto Sans !important;
}

#login_lo .title2 {
  font-family: Noto Sans !important;
}

#Choos .title {
  font-family: Noto Sans !important;
}

#Choos .system {
  display: flex;
  align-items: center;
  justify-content: center;
}

#Choos .system .system_logo {
  margin: 0 4px 0 0 !important;
}

.system_li .top_right b {
  display: flex;
  align-items: center;
  font-family: Noto Sans !important;
}

.system_li .top_right b span {
  font-family: Noto Sans !important;
}

.system_li .top_right div span {
  line-height: 50px;
}

.top_right span span {
  font-size: 16px;
  color: #9f9f9f !important;
}

.system_li .top_l_t {
  font-family: Noto Sans !important;
}

.system_li .option_o b {
  font-family: Noto Sans !important;
}

.el-checkbox__inner:hover {
  border-color: #00eec3 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #00eec3 !important;
  border-color: #00eec25b !important;
}

.isChecked > .el-checkbox__input > .el-checkbox__inner {
  border-color: red !important;
}

.el-checkbox__inner::after {
  border-color: #000;
}

html {
  font-family: "Noto Sans" !important;
}

.el-message--success {
  background: #edf2fc !important;
  border-color: #edf2fc !important;
}

.el-message--error {
  background: #edf2fc !important;
  border-color: #edf2fc !important;
}

.el-message__content {
  color: #000927 !important;
}

.noData {
  font-size: 16px;
  color: #c3c3c3;
  width: 100%;
  text-align: center;
  margin-top: 40px;
  font-family: Noto Sans !important;
  font-size: 14px;
  padding-bottom: 20px;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}

html {
  font-size: 36px;
}

body {
  margin: 0;
}

a {
  text-decoration: none;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border: none;
}

#formStr {
  text-align: left;
  padding: 0 0.5rem;
}

.loginButton {
  text-align: center;
  width: 360px;
  height: 50px;
  border-radius: 25px;
  background: #00eec3;
  font-size: 16px;
  font-weight: 700;
  color: #000927;
  line-height: 50px;
  margin: 0 auto 50px;
  -webkit-box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  cursor: pointer;
  font-family: Noto Sans !important;
  user-select: none;
}

body {
  background: #f3f5f7;
}

.el-icon--right {
  color: #00eec3;
}

.scrollBar {
  overflow: auto;
  overflow-y: scroll;
  overflow-x: hidden;
}

.scrollBar::-webkit-scrollbar {
  width: 2px;
  height: 1px;
}

.scrollBar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: transparent;
}

.scrollBar::-webkit-scrollbar-track {
  border-radius: 10px;
  background: transparent;
}

.helveticaBold {
  font-family: Noto Sans !important;
}

.helvetica {
  font-family: Noto Sans !important;
}

.smallTitle {
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  text-indent: 20px;
  line-height: 50px;
  padding-top: 5px;
  font-family: Noto Sans;
}

.smallTitle a {
  float: right;
  text-align: right;
  color: #0080ff;
  margin-right: 20px;
  font-weight: 400;
  font-size: 14px;
}

.timeAll_w {
  /* height: auto;
  overflow: hidden;
  padding: 20px 30px;
  width: 100%;
  border-bottom: 1px solid #e1e3e6; */
  width: 100%;
  height: 78px;
  border-bottom: 1px solid #e1e3e6;
  color: #000927;
  display: flex;
  align-items: center;
  padding-left: 30px;
  /* justify-content: center; */
}

.timeAll.el-range-editor.el-input__inner {
  width: 223px;
  height: 36px;
  overflow: hidden;
  background: #f6f8fa;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  font-size: 12px;
  line-height: 36px;
  color: #3f3f3f;
  float: left;
}

.timeAll2.timeAll.el-range-editor.el-input__inner {
  float: right;
}

.timeAll img {
  float: left;
  width: 16px;
  height: 16px;
  margin: 10px;
}

.timeDow {
  font-size: 12px;
  color: #00eec3;
  line-height: 36px;
  width: auto;
  float: left;
  text-align: right;
  cursor: pointer;
  margin-left: 6px;
}

.timeDow .el-dropdown-link {
  height: 36px;
  line-height: 36px;
  display: block;
}

.timeDow .el-dropdown-menu__item {
  padding: 10px 0;
}

.timeDow img {
  display: block;
  width: 16px;
  height: 16px;
  margin: 11px 5px;
  float: right;
}

.mytable {
  width: 94.5%;
  text-align: left;
  border: none;
  border-spacing: 0;
  margin: 0 auto 20px;
}

.mytable tr {
  height: 60px;

  /* text-indent: 30px; */
  border-radius: 12px;
  border: none;
}

.mytable tr:nth-child(2n) {
  background: #f6f8fa;
}

.mytable tr th {
  font-size: 14px;
  border: none;
  padding: 0 12px;
}

.mytable tr td {
  font-size: 12px;
  border: none;
  padding: 0 12px;
}

.Block {
  cursor: pointer;
  background: #00eec3;
  border-radius: 13px;
  width: 140px;
  padding: 0 6px;
  /* margin: 0 auto; */
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #000927;
  text-align: center;
  text-indent: 0;
}

.Block.mr {
  background: red;
  color: #fff;
}

.tab {
  width: 100%;
  border-bottom: 1px solid #e1e3e6;
  height: 60px;
}

.tab .tab_li {
  float: left;
  width: 160px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: Noto Sans;
  color: #000927;
  text-align: center;
  margin-top: 20px;
  position: relative;
  cursor: pointer;
  width: auto;
  margin-right: 20px;
  margin-left: 20px;
}

.tab .tab_li div {
  display: none;
  position: absolute;
  bottom: 0;
  width: 50%;
  height: 4px;
  border-radius: 4px 4px 0 0;
  background: #00eec3;
  left: calc((100% - 50%) / 2);
}

.tab .tab_li.mr {
  font-weight: 700;
}

.tab .tab_li.mr div {
  display: block;
}

.Popup {
  position: fixed;
  z-index: 9999999999999999999999999;
}

.Popup,
.Popup .Popups_w {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.Popup .Popups_w {
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
}

.Popup .Popups {
  background: #fff;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  border-radius: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
}

.Popup .Popups .close {
  position: absolute;
  top: 13px;
  right: 13px;
  width: 16px;
  height: 16px;
  display: block;
  cursor: pointer;
}

.page_title {
  font-size: 20px;
  color: #000927;
  font-weight: 700;
  line-height: 30px;
  padding: 37px 0 27px;
  font-family: Noto Sans !important;
}

.ShoppingCart_t_l.Guidance {
  font-family: Noto Sans !important;
}

.page_bo_li,
.page_title {
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
}

.page_bo_li {
  border-radius: 12px;
  border: 1px solid #e1e3e6;
  overflow: hidden;
  margin-bottom: 20px;
}

.twoButton {
  overflow: hidden;
  margin-top: 45px;
  margin-left: 5%;
}

.twoButton .BackButton {
  float: left;
  width: 196px;
  height: 40px;
  line-height: 40px;
  border: 2px solid #00eec3;
  border-radius: 22px;
  font-size: 15px;
  color: #000927;
  text-align: center;
  cursor: pointer;
}

.twoButton .loginButton {
  float: left;
  margin-left: 30px;
  width: 196px !important;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
}

.mes_a {
  margin: 0 auto;
  width: 286px;
}

.Contacts_li,
.pop_l,
.pop_li,
.tel_li {
  cursor: pointer;
}

.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 250px !important;
}

.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  background: none;
  line-height: 26px !important;
}

.el-date-editor .el-range__close-icon {
  width: 0;
}

.el-date-editor .el-range__icon {
  line-height: 28px !important;
}

.timeAll_w .el-icon--right {
  /* margin-right: 10px; */
  margin-left: 0;
}

.mes_a a {
  cursor: pointer;
}

.popper {
  top: 45px !important;
}

.el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #dcdfe6 !important;
  border-radius: 12px;
}
.el-pagination,
.pagination {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.el-select .el-input__inner:focus {
  border: 1px solid #01dbb3 !important;
  border-radius: 12px;
}

/* <div role="alert" class="el-message el-message--success" style="top: 20px; z-index: 2015;">
  <i class="el-message__icon el-icon-success"></i>
  <p class="el-message__content">参数不正确</p><!----></div> */
.el-select-dropdown__item.selected {
  color: #01dbb3 !important;
  font-weight: normal !important;
}

.el-dropdown {
  display: inline-block;
  position: relative;
  color: #00eec3 !important;
  font-size: 14px;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #01dbb3 !important;
  background-color: #01dbb307 !important;
}

/* .el-message--success{
  background-color: #01DBB3 !important;
  border-color: #01DBB3 !important;
}
.el-icon-success{
  color: #01DBB3 !important;
}
.el-message__content{
  color: #fff !important;
} */
.pagination {
  width: 100%;
  margin: 10px auto;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
}

.el-pagination {
  display: flex;
  height: 53px;
  align-items: center;
}

.el-pagination.is-background .el-pager {
  font-family: Noto Sans !important;
  font-size: 13px !important;
  color: #9f9f9f !important;
  border-color: #9f9f9f;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #000927 !important;
}

.el-loading-spinner i {
  color: #00eec3 !important;
}

.el-loading-spinner .el-loading-text {
  color: #00eec3 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00eec3 !important;
  color: #000927 !important;
  border: 0px !important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  border: 1px solid #9f9f9f !important;
  border-radius: 6px !important;
  width: 32px !important;
  height: 32px !important;
  background-color: #fff !important;
  line-height: 32px;
  border-radius: 6px !important;
  color: #9f9f9f !important;
  /* font-family: Noto Sans !important; */
  font-size: 13px !important;
  font-weight: 400 !important;
}

.el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev {
  color: #89909a !important;
}

video {
  object-fit: contain !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue